"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = compact;

function compact(arr) {
    var i = arr.length;
    while (i-- > 0) {
        if (!arr[i]) arr.splice(i, 1);
    }return arr;
}